import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom';
import './MenuPage.css';

const Index = () => {
    const tableData = JSON.parse(sessionStorage.getItem("urlParams"));
	// console.log('tableData', tableData)
	const [error, setError] = useState("");
	const navigate = useNavigate();

	useEffect(() => {
		if (!tableData) {
			setError("Something went wrong. Please scan the QR code again")
		}
	}, []);

  return (
    <div className="startWrap">
			<span className='error-validation p-4 mb-4'>{error}</span>
			<div className="start-menu-wrapper">
            <img src="/images/logo-white.png" alt='EZmenu' className="logo-icon" />
				<div className="button-wrap">
					<a
						href={`""`}
						onClick={ev => {
							ev.preventDefault();
							window.open('/view-document/Risen_Food_Menu')
						}}
					>
						<div className="btn-menu">
							<img src="/images/food-and-drink.svg" alt='food-and-drink' className="menu-icon" />
							<span className="btn-text">View Menu - Risen</span>
						</div>
					</a>
					<a
						href={`""`}
						onClick={ev => {
							ev.preventDefault();
							window.open('/view-document/Enas_Food')
						}}
					>
						<div className="btn-menu">
							<img src="/images/food-and-drink.svg" alt='food-and-drink' className="menu-icon" />
							<span className="btn-text">View Menu - Enas</span>
						</div>
					</a>
					{/* <a
						href={`""`}
						onClick={ev => {
							ev.preventDefault();
							navigate(`/ezmenu/${tableData.tableNumer}/${tableData.rvc}`)
						}}
					>
						<div className="btn-menu">
							<img src="/images/food-and-drink.svg" alt='food-and-drink' className="menu-icon" />
							<span className="btn-text">View & Order - Soluna Beach Club</span>
						</div>
					</a> */}
                </div>

            </div>
	</div>
  )
}

export default Index